const coldSandwiches = [
    {
        item: "Oven Roast Turkey",
        ingredients: "turkey, cranberry mayo, lettuce, red onions, tomato, pickles, provolone cheese"
    },
    {
        item: "California Turkey Club",
        ingredients: "turkey, bacon, cranberry mayo, lettuce, red onions, tomato, pickles, avocado, provolone cheese"
    },
    {
        item: "Tuna Salad",
        ingredients: "tuna, mayo, lettuce, tomato"
    },
    {
        item: "The Club",
        ingredients: "ham, turkey, bacon, mayo, mustard, lettuce, tomato, red onions, pickles, provolone cheese"
    },
    {
        item: "Italian Submarine",
        ingredients: "ham, salami, mortadella, capicola, mayo, mustard, italian dressing, pepperoncinis, lettuce, red onions, tomato, pickles, provolone cheese"
    },
    {
        item: "The Veggie",
        ingredients: "mayo, mustard, lettuce, pepperoncini, pickles, cucumbers, tomato, avocado, provolone cheese"
    }
]

export default coldSandwiches